import * as React from 'react';

const Loader = () => (
    <div className="loader">
        <div className="loader__inner"/>
        <div className="loader__inner__lg"/>
        <div className="loader__inner__md"/>
        <div className="loader__inner__sm"/>
    </div>
)

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Layout/Loader.tsx